// Sites whose videos we list from their official webmaster feeds and play in their own embeddable player
// (videos.frame_url, an iframe): Pornhub, from its daily dump (lib/pornhub), the WANKZ studio, from its
// export (lib/wankz.ts), FlyFLV, paysites' promo clips, from its export (lib/flyflv.ts), XVideos, from its
// database export (lib/xvideos.ts), XNXX, from its own, Ah-Me, from its feed of embed codes (lib/ahme.ts), Zilla's tubes (Xozilla, Analdin, XTits, XHand, Around,
// Homemade), from their dumps (lib/zilla.ts), and the WANKZ network's VR sites (WankzVR, MilfVR, POVR, TranzVR), from
// their exports (lib/wankz.ts), listed apart on /vr, and TubeCorporate's tubes (TXXX), from their embed
// feeds, with our campaign's id in the player (lib/tubecorporate.ts), and MagmaClick's (VXXX, InPorn, Xmilf…), from
// their affiliate feeds (lib/magmaclick.ts), and AnyCash's (BravoTube, AnyPorn, HellPorno…) and YLMCash's (YourLust, MyLust, AnySex, Xcafe), from their dumps (lib/anycash.ts). Also the studios whose trailers SexCash gives its
// affiliates (Pornbox, Private, Penthouse Gold: lib/sexcash.ts), which play in our own player instead. (RedTube's feed was left out: nearly all of its videos are Pornhub's own uploads,
// so it would only add copies.) Their terms allow embedding but not changing or covering the player, so
// these videos get no pre-roll of ours.
// Plain TypeScript: the import scripts use it too.

import { CDN } from "./cdn";

export interface FrameSource {
  /** Shown on the video page's credit line ("Pornhub"). */
  label: string;
  /**
   * Countries (ISO 3166, lower case) where the site itself doesn't play these videos (it blocks or
   * shows only safe-for-work content there over age-verification laws), so visitors from them aren't
   * offered the videos at all. US states that it blocks can't be told apart by country.
   */
  blockedCountries: readonly string[];
  /**
   * Its thumbnails are served from our address (app/api/thumbs): Pornhub's move and expire, FlyFLV's host
   * refuses other sites' pages.
   */
  proxyThumbs?: boolean;
  /**
   * Its feed has no view counts: its videos rank four months older in the trending order (the same
   * list, with the trailer sources, is in video_rank(), drizzle/0051) and show no "0 views".
   */
  noViews?: boolean;
  /** Its thumbnail is a cover with no stills for a hover preview (served at /thumbs/<id>/cover.jpg). */
  coverOnly?: boolean;
  /** VR scenes: listed on /vr, not in the video feeds (lib/api getFeed). */
  vr?: boolean;
  /**
   * Its videos play in our own player, with our pre-roll, from a fresh link to their file (lib/embeds.ts),
   * as the site allows; its iframe address stays stored, should we go back to its player.
   */
  ownPlayer?: boolean;
  /**
   * Its videos are a studio's trailers (videos.src, our own player, with a link to the full scene). They
   * rank four months older, like the sources without view counts, and their pages are indexed only from
   * TRAILER_INDEX_MIN_VIEWS views at the source.
   */
  trailer?: boolean;
}

// Pornhub, as of October 2026: France (blocked since July 2025, back with safe-for-work content only), the UK
// (new users turned away since February 2026), Australia (safe-for-work only since March 2026).
export const FRAME_SOURCES: Record<string, FrameSource> = {
  "pornhub.com": { label: "Pornhub", blockedCountries: ["fr", "gb", "au"], proxyThumbs: true },
  "wankz.com": { label: "WANKZ", blockedCountries: [], noViews: true },
  "flyflv.com": { label: "FlyFLV", blockedCountries: [], proxyThumbs: true, noViews: true },
  "xvideos.com": { label: "XVideos", blockedCountries: [], noViews: true },
  // XNXX, the same company's: the videos only it has, from its export (lib/xvideos.ts).
  "xnxx.com": { label: "XNXX", blockedCountries: [], noViews: true },
  // Ah-Me's feed of embed codes (lib/ahme.ts): its picture host refuses other sites' pages; small pictures, no stills.
  "ah-me.com": { label: "Ah-Me", blockedCountries: [], proxyThumbs: true, coverOnly: true },
  // Zilla's tubes, from their dumps (lib/zilla.ts): picture hosts refusing other sites' pages, no view counts.
  "xozilla.com": { label: "Xozilla", blockedCountries: [], proxyThumbs: true, coverOnly: true, noViews: true },
  "analdin.com": { label: "Analdin", blockedCountries: [], proxyThumbs: true, coverOnly: true, noViews: true },
  "xtits.com": { label: "XTits", blockedCountries: [], proxyThumbs: true, coverOnly: true, noViews: true },
  "xhand.com": { label: "XHand", blockedCountries: [], proxyThumbs: true, coverOnly: true, noViews: true },
  "around.xxx": { label: "Around", blockedCountries: [], proxyThumbs: true, coverOnly: true, noViews: true },
  "homemade.adult": { label: "Homemade", blockedCountries: [], proxyThumbs: true, coverOnly: true, noViews: true },
  // TubeCorporate's tubes (lib/tubecorporate.ts): played in our player, as TubeCorporate agreed.
  "txxx.com": { label: "TXXX", blockedCountries: [], ownPlayer: true },
  "hclips.com": { label: "HClips", blockedCountries: [], ownPlayer: true },
  "hotmovs.com": { label: "HotMovs", blockedCountries: [], ownPlayer: true },
  "upornia.com": { label: "Upornia", blockedCountries: [], ownPlayer: true },
  "hdzog.com": { label: "HDZog", blockedCountries: [], ownPlayer: true },
  "vjav.com": { label: "VJAV", blockedCountries: [], ownPlayer: true },
  "tubepornclassic.com": { label: "TubePornClassic", blockedCountries: [], ownPlayer: true },
  "shemalez.com": { label: "ShemaleZ", blockedCountries: [], ownPlayer: true },
  "thegay.com": { label: "TheGay", blockedCountries: [], ownPlayer: true },
  "porntop.com": { label: "PornTop", blockedCountries: [], ownPlayer: true },
  "manysex.com": { label: "ManySex", blockedCountries: [], ownPlayer: true },
  "ooxxx.com": { label: "OOXXX", blockedCountries: [], ownPlayer: true },
  "ourgay.com": { label: "OurGay", blockedCountries: [], ownPlayer: true },
  "pornl.com": { label: "PornL", blockedCountries: [], ownPlayer: true },
  "senzuri.tube": { label: "Senzuri", blockedCountries: [], ownPlayer: true },
  "xshemale.tube": { label: "XShemale", blockedCountries: [], ownPlayer: true },
  "desi-porn.tube": { label: "DesiPorn", blockedCountries: [], ownPlayer: true },
  // MagmaClick's tubes (lib/magmaclick.ts), from their affiliate feeds, with our campaign in the player.
  "vxxx.com": { label: "VXXX", blockedCountries: [] },
  "inporn.com": { label: "InPorn", blockedCountries: [] },
  "xmilf.com": { label: "Xmilf", blockedCountries: [] },
  "01tube.com": { label: "01Tube", blockedCountries: [] },
  "mrgay.com": { label: "MrGay", blockedCountries: [] },
  "boobse.com": { label: "Boobse", blockedCountries: [] },
  "bdsmx.tube": { label: "BDSMX", blockedCountries: [] },
  "gettranny.com": { label: "GetTranny", blockedCountries: [] },
  "blackporn.tube": { label: "BlackPorn", blockedCountries: [] },
  "lesbigo.com": { label: "LesbiGo", blockedCountries: [] },
  "xjav.tube": { label: "XJav", blockedCountries: [] },
  "porn-latina.com": { label: "PornLatina", blockedCountries: [] },
  "taboora.com": { label: "Taboora", blockedCountries: [] },
  "vr-porn.tube": { label: "VR Porn", blockedCountries: [], vr: true },
  "aniporn.com": { label: "AniPorn", blockedCountries: [] },
  // AnyCash's tubes (lib/anycash.ts), from its dumps: no views; some picture hosts refuse other sites' pages.
  "bravotube.net": { label: "BravoTube", blockedCountries: [], proxyThumbs: true, coverOnly: true, noViews: true },
  "anyporn.com": { label: "AnyPorn", blockedCountries: [], proxyThumbs: true, coverOnly: true, noViews: true },
  "hellporno.com": { label: "HellPorno", blockedCountries: [], noViews: true },
  "alphaporno.com": { label: "AlphaPorno", blockedCountries: [], noViews: true },
  "xbabe.com": { label: "Xbabe", blockedCountries: [], noViews: true },
  "tubewolf.com": { label: "TubeWolf", blockedCountries: [], noViews: true },
  "xcum.com": { label: "XCum", blockedCountries: [], proxyThumbs: true, coverOnly: true, noViews: true },
  "zedporn.com": { label: "ZedPorn", blockedCountries: [], proxyThumbs: true, coverOnly: true, noViews: true },
  "tubedupe.com": { label: "TubeDupe", blockedCountries: [], noViews: true },
  "tableterotica.com": { label: "TabletErotica", blockedCountries: [], noViews: true },
  "bravoerotica.com": { label: "BravoErotica", blockedCountries: [], proxyThumbs: true, coverOnly: true, noViews: true },
  // YLMCash's tubes (lib/anycash.ts), from its dumps: no views.
  "yourlust.com": { label: "YourLust", blockedCountries: [], noViews: true },
  "mylust.com": { label: "MyLust", blockedCountries: [], noViews: true },
  "anysex.com": { label: "AnySex", blockedCountries: [], noViews: true },
  "xcafe.com": { label: "Xcafe", blockedCountries: [], noViews: true },
  // The WANKZ network's VR sites: their image hosts refuse other sites' pages.
  "wankzvr.com": { label: "WankzVR", blockedCountries: [], proxyThumbs: true, coverOnly: true, noViews: true, vr: true },
  "milfvr.com": { label: "MilfVR", blockedCountries: [], proxyThumbs: true, coverOnly: true, noViews: true, vr: true },
  "povr.com": { label: "POVR", blockedCountries: [], proxyThumbs: true, coverOnly: true, noViews: true, vr: true },
  "tranzvr.com": { label: "TranzVR", blockedCountries: [], proxyThumbs: true, coverOnly: true, noViews: true, vr: true },
  // SexCash's studios' trailers.
  "pornbox.com": { label: "Pornbox", blockedCountries: [], trailer: true },
  "private.com": { label: "Private", blockedCountries: [], noViews: true, trailer: true },
  "penthousegold.com": { label: "Penthouse Gold", blockedCountries: [], noViews: true, trailer: true },
};

/** The trailer sources (`trailer`). */
export const TRAILER_SOURCES = Object.keys(FRAME_SOURCES).filter((s) => FRAME_SOURCES[s].trailer);

/**
 * A trailer's page is kept out of search engines below this many views at its source: half a minute of
 * someone else's scene makes a thin page.
 */
export const TRAILER_INDEX_MIN_VIEWS = 1000;

/** Whether our pre-roll ad plays before the studios' trailers: off until SexCash agrees to it in writing. */
export const TRAILER_PREROLL = false;

/** The VR sites' sources, which make up /vr. */
export const VR_SOURCES = Object.keys(FRAME_SOURCES).filter((s) => FRAME_SOURCES[s].vr);

/** Sources whose videos a visitor from `country` can't play, to leave out of what they're shown. */
export function blockedSourcesIn(country: string | null | undefined): string[] {
  if (!country) return [];
  return Object.entries(FRAME_SOURCES)
    .filter(([, s]) => s.blockedCountries.includes(country))
    .map(([source]) => source);
}

/**
 * Embedded videos with fewer views at their source than this are kept out of search engines (noindex,
 * left out of the sitemaps): a page that only frames another site's player is a copy, and a site of
 * mostly copies can lose ranking as a whole. The popular ones are indexed; lower it as the pages earn
 * traffic.
 */
export const FRAME_INDEX_MIN_VIEWS = 1_000_000;

/**
 * For the sources whose videos play in our own player (ownPlayer) the page is ours, not a frame of
 * another site's: indexed from this many views.
 */
export const OWN_PLAYER_INDEX_MIN_VIEWS = 100_000;

/** The sources whose videos play in our own player. */
export const OWN_PLAYER_SOURCES = Object.keys(FRAME_SOURCES).filter((s) => FRAME_SOURCES[s].ownPlayer);

/** The views from which an embedded video of `source` is indexed. */
export const frameIndexMinViews = (source: string | null | undefined) => (source && FRAME_SOURCES[source]?.ownPlayer ? OWN_PLAYER_INDEX_MIN_VIEWS : FRAME_INDEX_MIN_VIEWS);

/**
 * Where a video from a tube site's feed shows its thumbnail: our address (app/api/thumbs; static.sweet.xxx in
 * production, lib/cdn.ts), not the site's; a cover without stills at /thumbs/<id>/cover.jpg, which gets no hover preview.
 */
export const frameThumb = (videoId: string, coverOnly = false) => `${CDN}${coverOnly ? `/thumbs/${videoId}/cover.jpg` : `/thumbs/${videoId}.jpg`}`;

/** A picture whose host refuses other sites' pages (beeg's, from its feed: lib/beeg-feed.ts), served from our address too. */
export const refusesReferer = (thumb: string) => thumb.startsWith("https://thumbs.externulls.com/");

/** The thumbnail address a video is shown with: ours for the sources with proxyThumbs and pictures refusing other sites, others' as stored. */
export const shownThumb = (videoId: string, source: string | null, stored: string | null) =>
  stored && source && FRAME_SOURCES[source]?.proxyThumbs
    ? frameThumb(videoId, FRAME_SOURCES[source].coverOnly)
    : stored && refusesReferer(stored)
      ? frameThumb(videoId)
      : stored;

/**
 * For a studio's trailer (videos.src), the trailer itself: what its card plays while pointed at with a mouse
 * (VideoCard; the tubes' short preview clips are videos.preview).
 */
export const cardTrailer = (source: string | null, src: string | null) => (src?.startsWith("https://") && source && FRAME_SOURCES[source]?.trailer ? src : null);

/**
 * The 16 stills of a hover preview, or null: for a thumbnail at our address (/thumbs/<id>.jpg), and for an
 * XVideos or XNXX one (…/xv_15_t.jpg), spread over the 30 stills (xv_1_t to xv_30_t) each of its videos has.
 * Some at our address have none (beeg's, Pornhub's uploaded since mid-2025): the first answers 404, and
 * the card shows its thumbnail only.
 */
export function previewFrames(thumb: string | null | undefined): string[] | null {
  const id = (thumb?.startsWith(CDN) ? thumb.slice(CDN.length) : thumb)?.match(/^\/thumbs\/(\d{8,20})\.jpg$/)?.[1];
  if (id) return Array.from({ length: 16 }, (_, i) => `${CDN}/thumbs/${id}/${i + 1}.jpg`);
  const xvideos = thumb?.match(/^(https:\/\/thumbs?-[a-z0-9]+\.others-cdn\.com\/[0-9a-f-]{36}\/\d+\/)xv_\d{1,2}_t\.jpg$/)?.[1];
  return xvideos ? Array.from({ length: 16 }, (_, i) => `${xvideos}xv_${1 + Math.round((i * 29) / 15)}_t.jpg`) : null;
}

/**
 * A studio's site to send a viewer to, with our affiliate code: for SexCash's studios (trailer sources),
 * the query SEXCASH_LINK_QUERY in .env.local adds to every link (e.g. "affiliateID=…", as SexCash's panel
 * shows it). Other sources' links are left as they are.
 */
export function partnerUrl(origin: string | null | undefined, url: string) {
  const query = process.env.SEXCASH_LINK_QUERY?.trim().replace(/^[?&]/, "");
  if (!query || !FRAME_SOURCES[origin ?? ""]?.trailer) return url;
  return `${url}${url.includes("?") ? "&" : "?"}${query}`;
}
